(function () {
  function updateBackdrop() {
    var hasOpenMenu = Array.prototype.some.call(document.querySelectorAll('[data-mega-menu][aria-hidden="false"]'), function (menu) {
      return menu.parentElement && menu.parentElement.classList.contains('is-dropdown-open');
    });
    document.documentElement.classList.toggle('mega-menu-is-open', hasOpenMenu);
  }

  function ensureBackdrop() {
    if (!document.querySelector('.mega-menu-backdrop')) {
      var backdrop = document.createElement('div');
      backdrop.className = 'mega-menu-backdrop';
      backdrop.setAttribute('aria-hidden', 'true');
      document.body.appendChild(backdrop);
    }
  }

  function closeMobileSearch() {
    var wrapper = document.querySelector('.header__search-bar-wrapper');

    if (!wrapper || (!wrapper.classList.contains('is-visible') && !wrapper.classList.contains('is-fixed'))) {
      return;
    }

    wrapper.classList.remove('is-visible', 'is-fixed');
    var header = document.querySelector('.header');

    if (header) {
      header.classList.remove('header--search-expanded');
    }
    document.body.classList.remove('no-mobile-scroll');

    if (document.querySelector('#mobile-menu[aria-hidden="false"]')) {
      document.body.classList.add('no-mobile-scroll');
    }
  }

  function initializeMobileHeader() {
    if (document.documentElement.dataset.mobileHeaderReady === 'true') {
      return;
    }

    document.documentElement.dataset.mobileHeaderReady = 'true';

    document.addEventListener('click', function (event) {
      var searchToggle = event.target.closest('[data-action="toggle-search"]');
      var menuToggle = event.target.closest('[data-action="toggle-menu"]');

      if (searchToggle) {
        window.setTimeout(function () {
          var wrapper = document.querySelector('.header__search-bar-wrapper');

          if (wrapper && !wrapper.classList.contains('is-visible')) {
            closeMobileSearch();
          }
        }, 0);
      }

      if (menuToggle) {
        window.setTimeout(closeMobileSearch, 0);
      }
    });
  }

  function activatePanel(menu, trigger) {
    var panelId = trigger.getAttribute('aria-controls');

    menu.querySelectorAll('[data-mega-menu-tab]').forEach(function (item) {
      var isActive = item === trigger;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-expanded', isActive ? 'true' : 'false');
    });

    menu.querySelectorAll('[data-mega-menu-panel]').forEach(function (panel) {
      var isActive = panel.id === panelId;
      panel.classList.toggle('is-active', isActive);
      panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });
  }

  function updateMenuInteractivity(menu) {
    var owner = menu.parentElement;
    var isOpen = menu.getAttribute('aria-hidden') === 'false' && owner && owner.classList.contains('is-dropdown-open');

    if (isOpen) {
      menu.removeAttribute('inert');
    } else {
      menu.setAttribute('inert', '');
    }
  }

  function updateMenuPosition(menu) {
    if (menu.classList.contains('mega-menu--floating')) {
      return;
    }

    var header = menu.closest('.header');
    var navigation = menu.closest('.header__inline-navigation');
    var linkList = navigation && navigation.querySelector('.nav-bar__linklist');

    if (!header || !linkList) {
      return;
    }

    var headerRect = header.getBoundingClientRect();
    var linkListRect = linkList.getBoundingClientRect();
    var inlineStart = Math.max(0, linkListRect.left - headerRect.left);
    var edgeGap = window.innerWidth < 1440 ? 16 : 20;
    var availableWidth = Math.max(0, window.innerWidth - linkListRect.left - edgeGap);

    menu.style.setProperty('--mega-menu-inline-start', Math.round(inlineStart) + 'px');
    menu.style.setProperty('--mega-menu-available-width', Math.round(availableWidth) + 'px');
  }

  function updateMenuPositions() {
    document.querySelectorAll('[data-mega-menu]').forEach(updateMenuPosition);
  }

  function initializeMenu(menu) {
    if (menu.dataset.megaMenuReady === 'true') {
      return;
    }

    menu.dataset.megaMenuReady = 'true';

    var firstTrigger = menu.querySelector('[data-mega-menu-tab]');
    var owner = menu.parentElement;

    updateMenuInteractivity(menu);
    updateMenuPosition(menu);

    menu.querySelectorAll('[data-mega-menu-tab]').forEach(function (trigger) {
      trigger.addEventListener('mouseenter', function () {
        activatePanel(menu, trigger);
      });

      trigger.addEventListener('focus', function () {
        activatePanel(menu, trigger);
      });
    });

    menu.addEventListener('mouseleave', function () {
      if (firstTrigger) {
        activatePanel(menu, firstTrigger);
      }
    });

    if ('MutationObserver' in window && firstTrigger) {
      new MutationObserver(function () {
        if (menu.getAttribute('aria-hidden') === 'false') {
          activatePanel(menu, firstTrigger);
        }

        updateMenuInteractivity(menu);
        updateBackdrop();
      }).observe(menu, { attributes: true, attributeFilter: ['aria-hidden'] });

      if (owner) {
        new MutationObserver(function () {
          updateMenuInteractivity(menu);
        }).observe(owner, { attributes: true, attributeFilter: ['class'] });
      }
    }
  }

  function initializeMenus(root) {
    root.querySelectorAll('[data-mega-menu]').forEach(initializeMenu);
  }

  function boot() {
    ensureBackdrop();
    initializeMobileHeader();
    initializeMenus(document);
    updateBackdrop();
    updateMenuPositions();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    ensureBackdrop();
    initializeMobileHeader();
    initializeMenus(event.target);
    updateBackdrop();
    updateMenuPositions();
  });

  window.addEventListener('resize', updateMenuPositions);
})();
